import { useState } from "react";
import serve1 from "../../../../assests/images/serve1.svg";
import BlogSection from "../../components/blog/blogsection";
import SectionLast from "../../components/sectionlast/SectionLast";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import servebg from '../../../../assests/newimages/servebg.png'
/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */
const useCaseSections = [
  {
    id: "compliance",
    number: "01",
    title: "Compliance",
    bg: "bg-white",
    textColor: "text-[#0f0e1a]",
    description:
      "We equip regulated financial institutions with the tools to streamline KYT compliance, quantify risk, and fortify AML controls.",
    hasDots: true,
    dotsLight: true,
    accordionItems: [
      {
        title: "Seamless KYT compliance",
        body: "Leverage our identity layer, a continuously growing attributions dataset integrated with proprietary algorithms. Gain unmatched visibility & understanding across the network down to every transaction, ensuring KYT compliance.",
      },
      {
        title: "Risk reports & monitoring",
        body: "Trace, analyze & alert. Our risk reports provide detailed categorical analysis of sector and entity level interactions. From sanctioned addresses to beneficial ownership of nested services, properly evaluate your counterparty and understand your risk.",
      },
    ],
  },
  {
    id: "investments",
    number: "02",
    title: "Investments",
    bg: "bg-[#100f1e]",
    textColor: "text-white",
    description:
      "With our blockchain intelligence providing a complete view of on-chain activity, you can identify key market participants, analyze trading patterns, build accurate risk models, and uncover new opportunities for your organization.",
    hasDots: false,
    accordionItems: [
      {
        title: "Counterparty risk assessment",
        body: "Know your risk, in digital assets hidden exposures can lead to catastrophic losses. Before executing large transactions—whether trading, lending, or providing liquidity—Elementus analyzes wallet histories, transactional patterns, and potential red flags to deliver a clear risk profile, ensuring you understand your exposure before committing capital.",
      },
      {
        title: "Venture forecasting",
        body: "Harness on-chain data to deliver actionable insights. Track token allocations, user engagement, and capital flows to find value drivers for sound investment decisions. With our tools, analysts can accurately assess project fundamentals, model risk, and determine valuation, ensuring informed decision-making and strategic investment.",
      },
    ],
  },
  {
    id: "investigations",
    number: "03",
    title: "Investigations",
    bg: "bg-white",
    textColor: "text-[#0f0e1a]",
    description:
      "For blockchain investigators, Element Us Labs transforms fragmented data into a unified map of digital asset flows. Our advanced forensic toolkit seamlessly connects disparate entities and wallets, uncovering hidden relationships and flagging anomalous patterns that signal illicit activity. This intelligence enables experts to meticulously identify bad actors and execute decisively with confidence.",
    hasDots: true,
    dotsLight: true,
    accordionItems: [
      {
        title: "Fraud detection",
        body: "Element Us Labs' actionable alerts and notifications eliminate false positives, enabling investigators to identify previously unknown risks and suspicious activity.",
      },
      {
        title: "Trace the flow of funds",
        body: "Follow assets as they move through the blockchain. Our patented technology de-anonymizes wallets and reveals the interconnected network of entities behind every transaction.",
      },
      {
        title: "Risk prevention",
        body: "Our solution generates a definitive risk report that analyzes past transaction flows and flags potential vulnerabilities—links to Ransomware & APT groups, darknet markets, and sanctioned entities—arming investigators to proactively safeguard your organization.",
      },
    ],
  },
  {
    id: "web3",
    number: "04",
    title: "Web3 / DeFi",
    bg: "bg-[#100f1e]",
    textColor: "text-white",
    description:
      "By combining compliance-focused tools with advanced analytics on market positioning and macro-level trends, Elementus empowers Web3 companies to strategically navigate challenges, confidently expand their offerings, and optimize decision-making for every phase of the crypto market cycle.",
    hasDots: false,
    accordionItems: [
      {
        title: "Compliance for DeFi",
        body: "Identify and mitigate suspicious activity before it becomes a compliance issue with Elementus' in-depth blockchain analysis, ensuring regulatory alignment and reduced risk exposure when handling external deposits or user funds.",
      },
      {
        title: "Market share insights",
        body: "Go beyond a basic competitor analysis. With Elementus' comprehensive data, gain a holistic view of participants, protocols, and user behavior to pinpoint emerging market opportunities, identify areas for expansion, and stay ahead of evolving trends in the Web3 space.",
      },
      {
        title: "Cycle & market dynamics",
        body: "By understanding where the DeFi sector stands in the broader crypto market cycle, organizations can make data-driven decisions on when to launch new products, initiatives, or marketing pushes based on on-chain metrics, user adoption rates, and overall sentiment.",
      },
    ],
  },
];


function AccordionItem({ title, body, dark }) {
  const [open, setOpen] = useState(false);

  const borderColor = dark ? "border-[#2d2458]" : "border-gray-200";
  const titleColor = dark ? "text-white" : "text-[#0f0e1a]";
  const bodyColor = dark ? "text-gray-300" : "text-gray-600";
  const btnBorder = dark ? "border-violet-500" : "border-violet-400";

  return (
    <div className={`border-t ${borderColor} py-10`}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-6 text-left"
      >
        {/* Title */}
        <span
          className={`text-2xl sm:text-3xl lg:text-4xl font-bold ${titleColor}`}
        >
          {title}
        </span>

        {/* Icon Button */}
        <span
          className={`shrink-0 w-12 h-12 rounded-full border ${btnBorder} flex items-center justify-center`}
        >
          <span className="text-violet-500 text-2xl leading-none">
            {open ? "×" : "+"}
          </span>
        </span>
      </button>

      {/* Body */}
      {open && (
        <p className={`mt-6 text-lg leading-relaxed ${bodyColor} max-w-2xl`}>
          {body}
        </p>
      )}
    </div>
  );
}

function PlatformDiagram() {
  return (
    <div className="bg-[#100f1e] px-3 sm:px-5 lg:px-10 py-16 sm:py-24">
      <div className="max-w-[1200px] mx-auto">
          <img src={servebg} alt="" />
      </div>
    </div>
  );
}

function MockDashboard({ dark, label = "elementus", type = "grid" }) {
  const bg = dark ? "bg-[#0d0c1a]" : "bg-[#0d0c1a]";

  if (type === "graph") {
    return (
      <div
        className={`${bg} rounded-2xl border border-violet-900 p-4 h-full min-h-[340px] relative`}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            {label === "PULSE" && (
              <span className="text-[10px] bg-violet-700 text-white px-2 py-0.5 rounded font-bold">
                PULSE
              </span>
            )}
            {label === "RADAR MODULE" && (
              <span className="text-[10px] bg-violet-700 text-white px-2 py-0.5 rounded font-bold">
                RADAR MODULE
              </span>
            )}
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 rounded-full bg-violet-500 flex items-center justify-center text-white text-[8px] font-bold">
                ε
              </div>
              <span className="text-white text-xs font-semibold">
                elementus
              </span>
            </div>
          </div>
          <span className="text-gray-500 text-lg">⋮</span>
        </div>
        {/* Node graph mockup */}
        <div className="border border-violet-800 rounded-xl p-4 h-56 relative overflow-hidden">
          <p className="text-gray-400 text-xs mb-3">
            {label === "RADAR MODULE"
              ? "Flow of Funds"
              : "Blockchain Activity Summary"}
          </p>
          {label === "RADAR MODULE" && (
            <div className="absolute top-3 right-3 bg-[#1a1535] border border-violet-700 rounded-lg px-3 py-1">
              <p className="text-gray-400 text-[9px]">Risk Assessment:</p>
              <p className="text-white text-xl font-bold">19%</p>
              <span className="text-[9px] bg-[#2d2458] text-white px-2 py-0.5 rounded-full">
                Moderate
              </span>
            </div>
          )}
          {/* Decorative nodes */}
          <div className="relative w-full h-36">
            {[
              [20, 50],
              [45, 20],
              [45, 70],
              [65, 35],
              [65, 65],
              [80, 20],
              [80, 50],
              [80, 75],
            ].map(([x, y], i) => (
              <div
                key={i}
                className="absolute w-7 h-7 rounded-full border border-violet-500 bg-[#1a1535] flex items-center justify-center"
                style={{
                  left: `${x}%`,
                  top: `${y}%`,
                  transform: "translate(-50%,-50%)",
                }}
              >
                {i === 3 && (
                  <div className="w-4 h-4 rounded bg-violet-500/60" />
                )}
              </div>
            ))}
            {/* Lines */}
            <svg
              className="absolute inset-0 w-full h-full"
              style={{ pointerEvents: "none" }}
            >
              {[
                [20, 50, 45, 20],
                [20, 50, 45, 70],
                [45, 20, 65, 35],
                [45, 70, 65, 65],
                [65, 35, 80, 20],
                [65, 35, 80, 50],
                [65, 65, 80, 50],
                [65, 65, 80, 75],
              ].map(([x1, y1, x2, y2], i) => (
                <line
                  key={i}
                  x1={`${x1}%`}
                  y1={`${y1}%`}
                  x2={`${x2}%`}
                  y2={`${y2}%`}
                  stroke="#4c1d95"
                  strokeWidth="1"
                />
              ))}
            </svg>
          </div>
          {/* Legend */}
          <div className="mt-2">
            <p className="text-gray-500 text-[9px] font-bold mb-1">Legend</p>
            <div className="flex gap-3">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 bg-gray-500 rounded-sm" />
                <span className="text-gray-400 text-[9px]">Wallet</span>
              </div>
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 bg-gray-500 rounded-full" />
                <span className="text-gray-400 text-[9px]">Single Address</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "portal") {
    return (
      <div
        className={`${bg} rounded-2xl border border-violet-900 p-4 h-full min-h-[340px]`}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-full bg-violet-500 flex items-center justify-center text-white text-[9px] font-bold">
              ε
            </div>
            <span className="text-white text-xs font-semibold">elementus</span>
          </div>
          <div className="flex items-center gap-2 border border-[#2d2458] rounded-lg px-3 py-1 flex-1 mx-4">
            <span className="text-gray-500 text-xs">🔍</span>
            <span className="text-gray-500 text-xs">
              Enter an address or transaction...
            </span>
          </div>
        </div>
        <div className="pt-4 px-2">
          <h3 className="text-violet-400 text-2xl font-bold mb-4">
            Welcome back, Peter!
          </h3>
          <p className="text-gray-400 text-xs mb-3">Recently Created</p>
          <div className="grid grid-cols-2 gap-3">
            {[
              {
                tag: "RADAR",
                hash: "opqrst...987654",
                desc: "Tracking for VASP Operation",
                time: "Updated yesterday at 13:12",
                coin: "₿",
              },
              {
                tag: "PULSE",
                hash: "bC1rst...9dwEn3",
                desc: "Report 329",
                time: "Created on 2022-10...",
                coin: null,
              },
            ].map((card, i) => (
              <div key={i} className="border border-[#2d2458] rounded-xl p-3">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[9px] bg-violet-800 text-violet-300 px-2 py-0.5 rounded font-bold">
                    {card.tag}
                  </span>
                  {card.coin && (
                    <span className="text-orange-400 text-sm">{card.coin}</span>
                  )}
                </div>
                <p className="text-white text-xs font-bold mb-1">{card.hash}</p>
                <p className="text-gray-400 text-[10px] mb-2">{card.desc}</p>
                <p className="text-gray-500 text-[9px]">● {card.time}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Default: grid dashboard
  return (
    <div
      className={`${bg} rounded-2xl border border-violet-900 p-4 h-full min-h-[340px]`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full bg-violet-500 flex items-center justify-center text-white text-[8px] font-bold">
            ε
          </div>
          <span className="text-white text-xs font-semibold">elementus</span>
        </div>
        <span className="text-gray-500 text-lg">⋮</span>
      </div>
      <div className="text-gray-400 text-xs mb-2 px-1">Welcome, Sabrina!</div>
      <div className="grid grid-cols-3 gap-2">
        {/* Left column: list */}
        <div className="bg-[#12102a] rounded-lg p-2 row-span-2">
          {[80, 65, 55, 70, 45, 55, 40, 60, 35, 50].map((w, i) => (
            <div
              key={i}
              className="h-1.5 rounded mb-1.5 bg-violet-600"
              style={{ width: `${w}%`, opacity: 0.6 + i * 0.03 }}
            />
          ))}
        </div>
        {/* Flow chart */}
        <div className="bg-[#12102a] rounded-lg p-2 col-span-2 h-20 relative overflow-hidden">
          <svg className="w-full h-full" viewBox="0 0 200 60">
            <path
              d="M 0 55 C 30 55 30 20 60 20 S 90 10 120 10 S 160 30 200 30"
              stroke="#7c3aed"
              strokeWidth="2"
              fill="none"
              opacity="0.7"
            />
            <path
              d="M 0 55 C 30 55 30 35 60 35 S 90 45 120 45 S 160 50 200 50"
              stroke="#4c1d95"
              strokeWidth="2"
              fill="none"
              opacity="0.5"
            />
          </svg>
        </div>
        {/* Bottom panels */}
        {[0, 1].map((i) => (
          <div
            key={i}
            className="bg-[#12102a] rounded-lg p-2 h-20 flex items-center justify-center"
          >
            <svg viewBox="0 0 60 60" className="w-12 h-12">
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="none"
                stroke="#2d2458"
                strokeWidth="10"
              />
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="none"
                stroke="#7c3aed"
                strokeWidth="10"
                strokeDasharray={`${(i === 0 ? 55 : 35) * 1.38} 138`}
                strokeDashoffset="34"
                strokeLinecap="round"
              />
            </svg>
          </div>
        ))}
        {/* Bar charts */}
        {[0, 1].map((i) => (
          <div
            key={i}
            className="bg-[#12102a] rounded-lg p-2 h-20 flex items-end gap-1"
          >
            {[30, 55, 40, 70, 45, 60, 35, 50, 65, 42].map((h, j) => (
              <div
                key={j}
                className="flex-1 rounded-t"
                style={{
                  height: `${h}%`,
                  backgroundColor: `rgba(124,58,237,${0.4 + j * 0.05})`,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

function UseCaseSection({ section, dashboardType }) {
  const isDark = section.bg === "bg-[#100f1e]";
  const dividerColor = isDark ? "border-[#2d2458]" : "border-gray-200";
  const descColor = isDark ? "text-gray-300" : "text-gray-600";
  const numColor = "text-violet-500";

  return (
    <section
      className={`${section.bg} px-5 sm:px-10 lg:px-16 py-16 sm:py-24 relative overflow-hidden`}
    >
      {/* Dot decoration top-right */}
      {section.hasDots && (
        <div
          className="absolute top-8 right-0 pr-2 sm:pr-6 hidden md:grid gap-3 z-0"
          style={{ gridTemplateColumns: "repeat(6, 2rem)" }}
        >
          {Array.from({ length: 30 }).map((_, i) => (
            <div
              key={i}
              className={`w-8 h-8 rounded-full ${
                [7, 13, 19].includes(i)
                  ? "bg-violet-300 opacity-60"
                  : "bg-violet-200 opacity-40"
              }`}
            />
          ))}
        </div>
      )}

      {/* Text Content (above dots) */}
      <div className="relative z-20">
        {/* Header */}
        <div className="flex items-baseline gap-4 mb-8 sm:mb-12">
          <span
            className={`text-3xl sm:text-4xl font-bold ${numColor} font-mono`}
          >
            {section.number}
          </span>

          <h2
            className={`text-4xl sm:text-5xl lg:text-6xl font-bold ${section.textColor}`}
          >
            {section.title}
          </h2>
        </div>

        {/* Description */}
        <p
          className={`${descColor} text-base sm:text-lg leading-relaxed max-w-md mb-12 sm:mb-16 sm:ml-24 lg:ml-32`}
        >
          {section.description}
        </p>
      </div>

      {/* Two-column: accordion + dashboard */}
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 relative z-10">
        {/* Accordion */}
        <div className={`w-full lg:w-[44%] border-b ${dividerColor}`}>
          {section.accordionItems.map((item, i) => (
            <AccordionItem
              key={i}
              title={item.title}
              body={item.body}
              dark={isDark}
            />
          ))}
        </div>

        {/* Dashboard mockup */}
        <div className="w-full lg:w-[56%]">
          <MockDashboard
            dark={isDark}
            type={dashboardType}
            label={
              dashboardType === "graph" && section.id === "investments"
                ? "PULSE"
                : dashboardType === "graph"
                  ? "RADAR MODULE"
                  : "elementus"
            }
          />
        </div>
      </div>
    </section>
  );
}

function Serve() {
  return (
    <div className="bg-white text-[#0f0e1a] overflow-x-hidden">
      {/* ── HERO ── */}
      <section className="bg-[#f5f4fa] px-5 sm:px-10 lg:px-16 py-32 relative overflow-hidden min-h-screen flex items-center">
        {/* Grid background */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "linear-gradient(#d1d5db 1px, transparent 1px), linear-gradient(90deg, #d1d5db 1px, transparent 1px)",
            backgroundSize: "36px 36px",
          }}
        />

        <div className="relative w-full flex flex-col lg:flex-row items-center gap-12 lg:gap-4">
          {/* ── LEFT ── */}
          <div className="w-full lg:w-1/2 z-10">
            <h1 className="text-4xl lg:text-6xl font-bold text-[#0f0e1a] leading-[1.05] mb-6">
              One toolkit, full
              <br />
              blockchain
              <br />
              <span className="text-violet-600 border-2 border-violet-600 rounded-full px-3 py-1 inline-block mt-2">
                visibility
              </span>
            </h1>

            <p className="text-gray-500 text-base leading-relaxed max-w-sm mt-8 mb-10">
              Delivering unrivaled on-chain intelligence, Elementus provides
              macro- and micro-level visibility to discover valuable market
              opportunities for a range of use cases, including{" "}
              <a href="#" className="text-violet-600 hover:underline">
                Compliance
              </a>
              ,{" "}
              <a href="#" className="text-violet-600 hover:underline">
                Investments
              </a>
              ,{" "}
              <a href="#" className="text-violet-600 hover:underline">
                Investigations
              </a>
              , and{" "}
              <a href="#" className="text-violet-600 hover:underline">
                Web3 / DeFi
              </a>
              .
            </p>

            <Link to={"/login"} className="bg-[#8932f6] text-white w-[230px] rounded-full py-2 px-4 gap-3 flex justify-between items-center">Request a demo <BsArrowRight/></Link>
          </div>

          {/* ── RIGHT: Dashboard Cards ── */}
          <div className="w-full lg:w-1/2 z-10 relative flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] h-[420px] sm:h-[480px]">
              {/* ── Top icon card (transaction swap) ── */}
              <div className="absolute top-0 left-8 z-20 bg-violet-200 rounded-2xl p-4 shadow-lg w-16 h-16 flex items-center justify-center">
                <svg viewBox="0 0 40 40" className="w-10 h-10" fill="none">
                  <rect
                    x="2"
                    y="8"
                    width="16"
                    height="10"
                    rx="2"
                    stroke="#7c3aed"
                    strokeWidth="2"
                    fill="none"
                  />
                  <rect
                    x="22"
                    y="22"
                    width="16"
                    height="10"
                    rx="2"
                    stroke="#7c3aed"
                    strokeWidth="2"
                    fill="none"
                  />
                  <path
                    d="M18 13h4M18 13l-2-2M18 13l-2 2"
                    stroke="#7c3aed"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                  <path
                    d="M22 27h-4M22 27l2-2M22 27l2 2"
                    stroke="#7c3aed"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              {/* ── Main pie chart card ── */}
              <div className="absolute top-6 right-0 w-full lg:w-[88%] bg-[#1a1730] rounded-2xl p-2 shadow-2xl">
                <div className="flex items-center gap-1 mb-3">
                  <div className="w-2 h-2 rounded-full bg-violet-400" />
                  <div className="h-1 w-24 bg-violet-400/60 rounded" />
                  <div className="ml-auto w-3 h-3 border border-violet-400/50 rounded-sm" />
                </div>
                <div className="flex items-center gap-4">
                  {/* SVG Pie/Donut */}
                  <svg viewBox="0 0 160 160" className="w-36 h-36 shrink-0">
                    {/* dark circle bg */}
                    <circle cx="80" cy="80" r="70" fill="#2d2650" />
                    {/* slices */}
                    <path
                      d="M80 80 L80 12 A68 68 0 0 1 148 80 Z"
                      fill="#6d28d9"
                    />
                    <path
                      d="M80 80 L148 80 A68 68 0 0 1 80 148 Z"
                      fill="#4c1d95"
                    />
                    <path
                      d="M80 80 L80 148 A68 68 0 0 1 14 105 Z"
                      fill="#7c3aed"
                    />
                    <path
                      d="M80 80 L14 105 A68 68 0 0 1 14 55 Z"
                      fill="#5b21b6"
                    />
                    <path
                      d="M80 80 L14 55 A68 68 0 0 1 80 12 Z"
                      fill="#3b0764"
                    />
                    {/* inner circle */}
                    <circle cx="80" cy="80" r="36" fill="#1a1730" />
                    {/* thin highlight slices */}
                    <path
                      d="M80 80 L110 44 A68 68 0 0 1 148 78 Z"
                      fill="#a78bfa"
                      opacity="0.3"
                    />
                  </svg>

                  {/* Legend bars */}
                  <div className="flex flex-col gap-2 flex-1">
                    {[
                      { w: "w-16", opacity: "opacity-100" },
                      { w: "w-20", opacity: "opacity-80" },
                      { w: "w-10", opacity: "opacity-60" },
                      { w: "w-14", opacity: "opacity-50" },
                      { w: "w-8", opacity: "opacity-40" },
                    ].map((b, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <div
                          className={`w-3 h-3 rounded-sm bg-violet-500 ${b.opacity}`}
                        />
                        <div
                          className={`h-2 ${b.w} bg-violet-400/40 rounded-full`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ── Bottom-left flow/sankey card ── */}
              <div className="absolute bottom-0 left-0 w-[55%] bg-[#1a1730] rounded-2xl p-4 shadow-2xl">
                <div className="flex items-center gap-1 mb-3">
                  <div className="h-1 w-8 bg-violet-400/70 rounded" />
                  <div className="ml-auto w-1 h-4 bg-violet-500 rounded-full" />
                </div>
                <svg viewBox="0 0 180 100" className="w-full h-auto">
                  {/* Sankey-style flow curves */}
                  <defs>
                    <linearGradient id="fg1" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="#7c3aed" stopOpacity="0.9" />
                      <stop
                        offset="100%"
                        stopColor="#4c1d95"
                        stopOpacity="0.6"
                      />
                    </linearGradient>
                    <linearGradient id="fg2" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="#6d28d9" stopOpacity="0.8" />
                      <stop
                        offset="100%"
                        stopColor="#3b0764"
                        stopOpacity="0.5"
                      />
                    </linearGradient>
                  </defs>
                  {/* flow bands */}
                  <path
                    d="M0,10 C60,10 60,20 180,20 L180,35 C60,35 60,25 0,25 Z"
                    fill="url(#fg1)"
                  />
                  <path
                    d="M0,28 C60,28 60,40 180,38 L180,52 C60,52 60,40 0,42 Z"
                    fill="url(#fg2)"
                  />
                  <path
                    d="M0,45 C60,45 60,55 180,55 L180,68 C60,68 60,58 0,58 Z"
                    fill="url(#fg1)"
                    opacity="0.7"
                  />
                  <path
                    d="M0,62 C60,62 60,72 180,75 L180,88 C60,88 60,78 0,75 Z"
                    fill="url(#fg2)"
                    opacity="0.6"
                  />
                  {/* left tick marks */}
                  {[12, 30, 48, 65, 82].map((y, i) => (
                    <rect
                      key={i}
                      x="0"
                      y={y}
                      width="4"
                      height="2"
                      fill="#a78bfa"
                      rx="1"
                    />
                  ))}
                  {/* right tick marks */}
                  {[22, 40, 58, 75, 92].map((y, i) => (
                    <rect
                      key={i}
                      x="176"
                      y={y}
                      width="4"
                      height="2"
                      fill="#a78bfa"
                      rx="1"
                    />
                  ))}
                </svg>
              </div>

              {/* ── Bottom-right risk assessment card ── */}
              <div className="absolute bottom-4 right-0 w-[42%] bg-[#1a1730] rounded-2xl p-4 shadow-2xl">
                <p className="text-gray-400 text-xs mb-1">Risk Assessment:</p>
                <p className="text-white text-4xl font-bold leading-none mb-3">
                  19%
                </p>
                <span className="inline-block border border-violet-400/60 text-violet-300 text-xs px-3 py-1 rounded-full">
                  Moderate
                </span>
              </div>

              {/* ── Bottom-right icon card (crypto) ── */}
              <div className="absolute -bottom-4 right-[-16px] sm:right-[-24px] z-20 bg-violet-200 rounded-2xl p-4 shadow-lg w-16 h-16 flex items-center justify-center">
                <svg viewBox="0 0 40 40" className="w-10 h-10" fill="none">
                  <circle
                    cx="20"
                    cy="20"
                    r="14"
                    stroke="#7c3aed"
                    strokeWidth="2"
                  />
                  <path
                    d="M20 8 L20 10 M20 30 L20 32 M8 20 L10 20 M30 20 L32 20"
                    stroke="#7c3aed"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M17 15h4a2 2 0 010 4h-4v-4z"
                    stroke="#7c3aed"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <path
                    d="M17 19h5a2 2 0 010 4h-5v-4z"
                    stroke="#7c3aed"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <line
                    x1="19"
                    y1="14"
                    x2="19"
                    y2="24"
                    stroke="#7c3aed"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <line
                    x1="21"
                    y1="14"
                    x2="21"
                    y2="24"
                    stroke="#7c3aed"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  {/* pulse rings */}
                  <circle
                    cx="20"
                    cy="20"
                    r="18"
                    stroke="#7c3aed"
                    strokeWidth="1"
                    strokeDasharray="3 3"
                    opacity="0.4"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── ANALYZE SECTION ── */}
      <section className="bg-[#100f1e] px-5 sm:px-10 lg:px-16 py-16 sm:py-24 relative overflow-hidden">
        {/* Dot grid bottom-left */}
        <div
          className="absolute bottom-8 left-8 hidden md:grid gap-3"
          style={{ gridTemplateColumns: "repeat(5, 2rem)" }}
        >
          {Array.from({ length: 25 }).map((_, i) => (
            <div
              key={i}
              className={`w-8 h-8 rounded-full ${i === 6 ? "bg-violet-500 opacity-80" : "bg-[#2d2458] opacity-50"}`}
            />
          ))}
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-12">
          <div className="w-full lg:w-1/2 z-10">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-tight">
              Analyze, connect,
              <br />
              outperform
            </h2>
          </div>
          <div className="w-full lg:w-1/2 z-10">
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              We empower organizations, financial institutions, and hedge funds
              with enhanced insights to illuminate the true pathways of digital
              currency on the blockchain. By combining cutting-edge analytics,
              holistic data coverage, and a qualitative human element,
              organizations can more easily track the flow of funds and identify
              trends. Whether your focus is compliance, investigatory, or
              digital asset strategy, Elementus can enhance your decision-making
              on the blockchain.
            </p>
          </div>
        </div>
      </section>

      {/* ── PLATFORM DIAGRAM ── */}
      <PlatformDiagram />

      {/* ── USE CASE SECTIONS ── */}
      <UseCaseSection section={useCaseSections[0]} dashboardType="grid" />
      <UseCaseSection section={useCaseSections[1]} dashboardType="graph" />
      <UseCaseSection section={useCaseSections[2]} dashboardType="graph" />
      <UseCaseSection section={useCaseSections[3]} dashboardType="portal" />

      <BlogSection />
      <SectionLast heading={"Ready for blockchain visibility?"} />
    </div>
  );
}

export default Serve;
